var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-[8.8rem] min-w-[8.8rem] max-h-full md:w-[46.6rem] md:block h-[8.8rem] md:h-[46.6rem] md:p-8 opacity-10"},[_c('div',{staticClass:"bg-grey-400 w-full h-full"})])
}]

export { render, staticRenderFns }